module.exports = __webpack_public_path__ + "static/project4-b1b01e7d6e793d2940b47956dd14789e.png";